<app-header></app-header>
<div id="signature">
  <div class="container-12 pr-36px pl-36px desktop">
    <div class="row">
      <div class="col">
        <strong class="f-32">
          {{i18n.SIGNATURE.SEU_DOCUMENTO}}
        </strong>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <div class="row pb-20px align-items-center">
          <div ngbDropdown placement="right-bttom">
            <span class="f-18 f-bold link" ngbDropdownToggle > <img src=".././../../assets/icons/DESKTOP/ic_cloud_download_24px.png" alt=""> Download <img src="../../../assets/icons/DESKTOP/Grupo 192.png" alt=""></span>
            <div class="dropdown-menu" ngbDropdownMenu>
              <button ngbDropdownItem (click)="prepareDownload('signed')" *ngIf="canDownload">
                <img src="../../../assets/icons/DESKTOP/ic_picture_as_pdf_24px.png" alt="">{{i18n.SIGNATURE.DOWNLOAD_PDF}}
              </button>
              <button ngbDropdownItem (click)="prepareDownload('original')">
                <img src="../../../assets/icons/DESKTOP/ic_picture_as_pdf_24px.png" alt="">{{i18n.SIGNATURE.DOWNLOAD_ZIP}}
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <iframe frameborder="0" class="w-100 h-1000px" [src]="documentUrl | safe"></iframe>
          </div>
        </div>
      </div>
      <div class="col pl-24px">

        <div class="row center align-items-center">
          <div class="col">
            <div class="logo">
              <span class="f-32 bold">
                <img src="../../../assets/img/logo_go_contratos.png" alt="">
              </span>
            </div>
          </div>
        </div>

        <div class="row pt-32px pl-16px">
          <div class="col-1">
            <img src="../../../assets/icons/DESKTOP/ic_description_24px.png" alt="">
          </div>
          <div class="col">
            <span class="f-18" *ngIf="documentName">{{documentName}}.pdf</span>
            <br>
            <span class="f-12">{{uidDoc}}</span>
          </div>
        </div>
        <div class="row pt-24px">
          <div class="col">
            <button class="btn btn-default align-items-center" (click)="openModal()" *ngIf="!canDownload">
              <img src="../../../assets/icons/DESKTOP/Grupo 260.png" alt="">&nbsp;
              <span class="upper-case">
                {{i18n.SIGNATURE.ASSINAR_COMO_UPERCASE}} {{subscriber?.type}}
              </span>
            </button>
          </div>
        </div>

        <div class="row pt-16px" *ngIf="signerList">
          <div class="col">
            <app-subscriber-list [signerList]="signerList"></app-subscriber-list>
          </div>
        </div>

        <div class="row pt-34px align-items-center">
          <div class="col">
            <app-signer-history [signerHistory]="signerHistory"></app-signer-history>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="container mobile pt-24px">
    <div class="row pb-20px">
      <div class="col center">
        <img src="../../../assets/img/logo_go_contratos.png" alt="" class="logo-mobile">
      </div>
    </div>
    <div *ngIf="!mobileShowSignForm">
      <div class="row pb-20px">
        <div class="col center">
          <span class="f-20 f-bold f-d-blue">{{i18n.SIGNATURE.SEU_DOCUMENTO}}</span>
        </div>
      </div>
      <div class="row pb-12px">
        <div class="col pl-4px pr-4px" *ngIf="!canDownload">
          <button class="btn btn-default-mobile align-items-center" (click)="showFormMobile()">
            <img src="../../../assets/icons/DESKTOP/Grupo 260.png" class="mobile-btn-icon" alt="">&nbsp;
            <span class="upper-case">
              {{i18n.SIGNATURE.ASSINAR_COMO_UPERCASE}} {{subscriber?.type}}
            </span>
          </button>
        </div>
        <div class="col pr-4px pl-4px">
          <app-signers-button [signerList]="signerList"></app-signers-button>
        </div>
      </div>
      <div class="row pb-12px">
        <div class="col-1">
          <img src="../../../assets/icons/DESKTOP/ic_description_24px.png" class="mobile-icon" alt="">
        </div>
        <div class="col f-12">
          <span *ngIf="documentName" class="f-12">{{documentName}}.pdf</span>
          <br>
          <span class="f-8">{{uidDoc}}</span>
        </div>
      </div>
      <div class="row pb-16px">
        <div class="col">
          <div ngbDropdown placement="right">
            <span class="f-20 f-bold link" ngbDropdownToggle > <img src=".././../../assets/icons/MOBILE/ic_cloud_download_24px.png" alt=""> Download <img src="../../../assets/icons/MOBILE/Grupo 192.png" alt=""></span>
            <div class="dropdown-menu" ngbDropdownMenu>
              <button ngbDropdownItem (click)="prepareDownload('signed')" class="f-8" *ngIf="canDownload">
                <img src="../../../assets/icons/DESKTOP/ic_picture_as_pdf_24px.png" alt="">{{i18n.SIGNATURE.DOWNLOAD_PDF}}
              </button>
              <button ngbDropdownItem (click)="prepareDownload('original')" class="f-8">
                <img src="../../../assets/icons/DESKTOP/ic_markunread_mailbox_24px.png" alt="">{{i18n.SIGNATURE.DOWNLOAD_ZIP}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row pb-24px">
        <div class="col">
          <iframe frameborder="0" class="w-100 h-420px" [src]="documentUrlMobile | safe"></iframe>
        </div>
      </div>
      <div class="row align-items-center pb-20px">
        <div class="col">
          <app-signer-history [signerHistory]="signerHistory"></app-signer-history>
        </div>
      </div>
    </div>

    <div *ngIf="mobileShowSignForm">
      <app-signer-mobile-form [signupInformations]="valueFormMobile" (openForm)="mobileShowSignForm = $event"></app-signer-mobile-form>
    </div>

  </div>
</div>
<app-signature-footer></app-signature-footer>
